export const _state = {
    isGetCompanyDateFetch: false,
    isGetCompaniesFetch: false,
    isGetCompanyFetch: false,
    isPutCompanyFetch: false,
    isPostCompanyFetch: false,
    errors: [],
    companies: [],
    company: {},
    dates: [],
};

export function companiesReducer(state = _state, action) {

    switch (action.type) {

        case 'API_GET_COMPANY_DATE_CLOSE_FETCH':
            return {
                ...state,
                isGetCompanyDateFetch: false
            };

        case 'API_GET_COMPANY_CLOSE_FETCH':
            return {
                ...state,
                isGetCompanyFetch: false
            };

        case 'API_GET_COMPANIES_CLOSE_FETCH':
            return {
                ...state,
                isGetCompaniesFetch: false
            };

        case 'API_POST_COMPANY_CLOSE_FETCH':
            return {
                ...state,
                isPostCompanyFetch: false
            };

        case 'API_PUT_COMPANY_CLOSE_FETCH':
            return {
                ...state,
                isPutCompanyFetch: false
            };

        case 'COMPANY_INITIALIZE':
            return {
                ..._state,
            };

        case 'API_COMPANY_INIT':
            return {
                ...state,
                company: {},
                isGetCompanyFetch: true
            };

        case 'API_GET_CURRENT_COMPANY':
            return {
                ...state,
                isGetCompanyFetch: true,
            };

        case 'API_GET_CURRENT_COMPANY_SUCCESS':
            return {
                ...state,
                errors: [],
                company: action.payload.data
            };

        case 'API_GET_CURRENT_COMPANY_FAIL':
            return {
                ...state,
                errors: action.error.response.data
            };

        case 'API_PUT_COMPANY':
            return {
                ...state,
                isPutCompanyFetch: true,
            };

        case 'API_PUT_COMPANY_SUCCESS':
            return {
                ...state,
                errors: [],
                company: action.payload.data
            };

        case 'API_PUT_COMPANY_FAIL':
            return {
                ...state,
                errors: action.error.response.data
            };

        case 'API_POST_COMPANY':
            return {
                ...state,
                isPostCompanyFetch: true,
            };

        case 'API_POST_COMPANY_SUCCESS':
            return {
                ...state,
                errors: [],
                company: action.payload.data,
            };

        case 'API_POST_COMPANY_FAIL':
            return {
                ...state,
                errors: action.error.response.data
            };

        case 'API_GET_COMPANIES':
            return {
                ...state,
                isGetCompaniesFetch: true,
            };

        case 'API_GET_COMPANIES_SUCCESS':
            return {
                ...state,
                errors: [],
                companies: action.payload.data,
            };

        case 'API_GET_COMPANIES_FAIL':
            return {
                ...state,
                errors: action.error.response.data
            };

        case 'API_GET_COMPANY':
            return {
                ...state,
                isGetCompanyFetch: true,
            };

        case 'API_GET_COMPANY_SUCCESS':
            return {
                ...state,
                errors: [],
                company: action.payload.data,
            };

        case 'API_GET_COMPANY_FAIL':
            return {
                ...state,
                errors: action.error.response.data
            };

        case 'API_GET_COMPANY_DATES':
            return {
                ...state,
                isGetCompanyDateFetch: true
            };

        case 'API_GET_COMPANY_DATES_SUCCESS':
            return {
                ...state,
                dates: action.payload.data
            };

        case 'API_GET_COMPANY_DATES_FAIL':
            return {
                ...state,
                errors: action.error.response.data
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/companies.js